<template>
  <div class="section-main__warp">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="handleSearchChange"
      @search-reset="handleSearchReset" @size-change="handleSizeChange" @current-change="handleCurrentChange">
      <template slot="menuLeft">
        <el-button type="primary" size="small" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">
          上报
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
          <i class="el-icon-tickets" @click="handleView(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 4px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="处置" placement="top" popper-class="tooltip-draw"
          v-if="scope.row.reportStates == 1">
          <i class="el-icon-thumb" @click="handleDeal(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 4px;"></i>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="删除" placement="top" popper-class="tooltip-draw"
          v-if="scope.row.reportStates == 2">
          <i class="el-icon-delete" @click="handleDel(scope.row, scope.index)"
            style="font-size: 16px; color: #407AEE; cursor: pointer; margin: 0 4px;"></i>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog title="事件上报" :visible.sync="addVisible" append-to-body :close-on-click-modal="addModalClose"
      :before-close="addDialogClose" width="42%">
      <el-form :model="addForm" ref="addForm" :rules="addRules" label-width="120px">
        <el-row>
          <el-form-item label="上报事件" prop="reportName">
            <el-input v-model="addForm.reportName" placeholder="请输入上报事件" clearable></el-input>
          </el-form-item>
          <el-form-item label="紧急程度" prop="reportLevel">
            <el-select v-model="addForm.reportLevel" placeholder="请选择紧急程度" clearable>
              <el-option v-for="item in reportLevelArr" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="报修设备" prop="deviceName">
            <el-input v-model="addForm.deviceName" placeholder="请选择报修设备" clearable @click.native="deviceSelect">
              <i slot="suffix" @click="deviceSelect" class="el-input__icon el-icon-more"
                style="cursor: pointer;"></i></el-input>
          </el-form-item>
          <el-form-item label="上报位置" prop="reportPosition">
            <el-input v-model="addForm.reportPosition" placeholder="请输入上报位置" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="上报人" prop="personName">
            <el-input v-model="addForm.personName" placeholder="请输入上报人" readonly style="width: 108%;"></el-input>
          </el-form-item>
          <el-form-item label="上报时间" prop="reportTime" label-width="135px">
            <el-date-picker v-model="addForm.reportTime" type="datetime" placeholder="请选择上报时间"
              value-format="yyyy-MM-dd HH:mm:ss" clearable />
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="上报图片" prop="">
            <el-upload ref="addUpload" action="/common/file/batchFileload.json" list-type="picture-card"
              accept="image/png, image/jpg, image/jpeg" name="files" :on-success="onSuccessFile"
              :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addConfirm('addForm')">确 定</el-button>
        <el-button @click="addCancel">取 消</el-button>
      </div>
    </el-dialog>
    <DeviceSelect ref="deviceSelect" @selectArr="receiveDevice"></DeviceSelect>
    <PeopleSelect ref="peopleSelect" @selectArr="receivePeople"></PeopleSelect>
    <el-dialog title="事件处置" :visible.sync="dealVisible" append-to-body :close-on-click-modal="dealModalClose" width="42%">
      <el-form :model="dealForm" ref="dealForm" :rules="dealRules" label-width="120px">
        <el-row>
          <el-form-item label="处置类型" prop="reportStates">
            <el-radio-group v-model="dealForm.reportStates">
              <el-radio :label="3">确认，派单处理</el-radio>
              <el-radio :label="2">误报，取消</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row v-if="dealForm.reportStates === 3">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="dealForm.taskName" placeholder="请输入任务名称" clearable readonly></el-input>
          </el-form-item>
          <el-form-item label="紧急程度" prop="taskLevel">
            <el-select v-model="dealForm.taskLevel" placeholder="请选择紧急程度" clearable>
              <el-option v-for="item in taskLevelArr" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row v-if="dealForm.reportStates === 3">
          <el-form-item label="执行人员" prop="operatePerson">
            <el-input v-model="dealForm.operatePerson" placeholder="请选择执行人" clearable @click.native="peopleSelect">
              <i slot="suffix" @click="peopleSelect" class="el-input__icon el-icon-more"
                style="cursor: pointer;"></i></el-input>
          </el-form-item>
          <el-form-item label="要求完成时间" prop="taskTime">
            <el-date-picker v-model="dealForm.taskTime" type="datetime" placeholder="请选择要求完成时间"
              value-format="yyyy-MM-dd HH:mm:ss" clearable />
          </el-form-item>
        </el-row>
        <el-row v-if="dealForm.reportStates === 3">
          <el-col :span="21">
            <el-form-item label="处理要求" prop="taskAsk">
              <el-input v-model="dealForm.taskAsk" placeholder="请输入处理要求" clearable type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dealConfirm('dealForm')">确 定</el-button>
        <el-button @click="dealCancel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="详情" :visible.sync="detailVisible" append-to-body :close-on-click-modal="detailModalClose"
      :before-close="detailDialogClose" width="42%">
      <el-descriptions border>
        <el-descriptions-item label="上报编号">{{ detailForm.reportCode }}</el-descriptions-item>
        <el-descriptions-item label="上报时间">{{ detailForm.reportTime }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag size="small" type="warning">{{ reportStatesRender(detailForm.reportStates) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="紧急程度">
          <el-tag size="small" type="warning">{{ reportLevelRender(detailForm.reportLevel) }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="上报人">{{ detailForm.personName }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ detailForm.phone }}</el-descriptions-item>
        <el-descriptions-item label="厂家">{{ detailForm.factory }}</el-descriptions-item>
        <el-descriptions-item label="报修设备">{{ detailForm.deviceName }}</el-descriptions-item>
        <el-descriptions-item label="上报事件">{{ detailForm.reportName }}</el-descriptions-item>
        <el-descriptions-item label="位置">{{ detailForm.reportPosition }}</el-descriptions-item>
      </el-descriptions>
      <div class="demo-image__preview" v-if="detailForm.reportImagesArr.length > 0">
        <div style="margin: 15px 10px 10px 10px; color: #000000; font-size: 12px;">上报图片：</div>
        <div style="margin: 0 10px; display: flex;">
          <div v-for="item in detailForm.reportImagesArr" :key="item" style="margin: 0 10px 10px 0;">
            <el-image style="width: 100px; height: 100px" :src="getImgPath(item)"
              :preview-src-list="[getImgPath(item)]"></el-image>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailCancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import { api } from "../api";
import tableOption from "../config/receiveTable";
import { formatTimeToStr } from "../filter/dateUtils";
import utils from "@src/common/utils";
import { Cache } from "$utils";
import DeviceSelect from "../components/deviceSelect.vue"
import PeopleSelect from "../components/peopleSelect.vue"
export default {
  components: {
    DeviceSelect,
    PeopleSelect
  },
  data() {
    return {
      option: tableOption(this),
      tableData: [],
      searchForm: {},
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      addRules: {
        reportName: [{ required: true, message: '请输入上报事件', trigger: ['blur', 'change'] }],
        reportLevel: [{ required: true, message: '请选择紧急程度', trigger: ['change', 'blur'] }]
      },
      addVisible: false,
      addModalClose: false,
      addForm: {
        reportName: '',
        reportLevel: '',
        deviceName: '',
        reportDevice: '',
        reportPosition: '',
        personName: '',
        reportPerson: '',
        reportTime: '',
        reportImages: ''
      },
      fileList: [],
      reportLevelArr: [
        {
          label: '特急',
          value: 1
        },
        {
          label: '紧急',
          value: 2
        },
        {
          label: '一般',
          value: 3
        }
      ],
      // 事件处置
      dealVisible: false,
      dealModalClose: false,
      dealForm: {
        reportStates: 3,
        taskName: '',
        taskLevel: '',
        person: '',
        operatePerson: '',
        taskTime: '',
        taskAsk: ''
      },
      taskLevelArr: [
        {
          label: '特急',
          value: 1
        },
        {
          label: '紧急',
          value: 2
        },
        {
          label: '一般',
          value: 3
        }
      ],
      dealRules: {
        reportStates: [{ required: true, message: '请选择处置类型', trigger: ['blur', 'change'] }],
        taskName: [
          { required: true, message: '请输入任务名称', trigger: ['blur', 'change'] },
          { min: 1, max: 255, trigger: 'blur' }
        ],
        operatePerson: [{ required: true, message: '请选择人员', trigger: ['blur', 'change'] }],
        taskLevel: [{ required: true, message: '请选择紧急程度', trigger: ['change', 'blur'] }],
        taskTime: [{ required: true, message: '请选择时间', trigger: ['blur', 'change'] }]
      },
      // 详情
      detailVisible: false,
      detailModalClose: false,
      detailForm: {
        reportCode: null,
        reportStates: null,
        reportTime: null,
        reportLevel: null,
        personName: null,
        deviceName: null,
        reportName: null,
        reportPosition: null,
        reportImages: null,
        reportImagesArr: []
      }
    };
  },
  created() { },
  mounted() {
    this.getList();
  },
  methods: {
    handleUpdate() {
      this.getList();
    },
    handleSearchChange(param) {
      this.searchForm = { ...param };
      this.getList();
    },
    handleSearchReset() {
      this.searchForm = {};
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    getList() {
      let params = {
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
        reportCode: this.searchForm.reportCode,
        reportName: this.searchForm.reportName,
        reportStates: this.searchForm.reportStates,
        deviceName: this.searchForm.deviceName,
        reportDevice: this.searchForm.reportDevice,
        reportLevel: this.searchForm.reportLevel
      };
      if (this.searchForm.reportTime && this.searchForm.reportTime.length > 0) {
        params.startDate = formatTimeToStr(this.searchForm.reportTime[0]);
        params.endDate = formatTimeToStr(this.searchForm.reportTime[1]);
      }
      this.$fetch(api.queryReceiveReportList, params).then((response) => {
        if (response.success) {
          this.tableData = response.data.list;
          this.page.total = response.data ? response.data.total : 0;
        } else {
          this.$message.error(response.msgContent || "获取接单管理列表失败");
        }
      });
    },
    handleAdd() {
      const account = Cache.get("CACHE_USER_INFO");
      this.addForm.reportName = ''
      this.addForm.reportLevel = ''
      this.addForm.deviceName = ''
      this.addForm.reportPosition = ''
      this.addForm.personName = account.nickName
      this.addForm.reportPerson = account.account
      this.addForm.reportTime = ''
      this.addForm.reportImages = ''
      this.fileList = []
      this.addVisible = true;
    },
    deviceSelect() {
      this.addForm.deviceName = ''
      this.addForm.reportDevice = ''
      this.addForm.reportPosition = ''
      this.$refs.deviceSelect.openDialog()
    },
    receiveDevice(val) {
      this.addForm.deviceName = val.deviceName
      this.addForm.reportDevice = val.deviceId
      this.addForm.reportPosition = val.location
    },
    addCancel() {
      this.addForm.reportName = ''
      this.addForm.reportLevel = ''
      this.addForm.deviceName = ''
      this.addForm.reportDevice = ''
      this.addForm.reportPosition = ''
      this.addForm.personName = ''
      this.addForm.reportPerson = ''
      this.addForm.reportTime = ''
      this.addForm.reportImages = ''
      this.fileList = []
      this.$refs.addUpload.clearFiles()
      this.addVisible = false;
    },
    addDialogClose() {
      this.$refs.addUpload.clearFiles()
      this.addVisible = false;
    },
    addConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            reportName: this.addForm.reportName,
            reportLevel: this.addForm.reportLevel,
            deviceName: this.addForm.deviceName,
            reportPosition: this.addForm.reportPosition,
            personName: this.addForm.personName,
            reportPerson: this.addForm.reportPerson,
            reportTime: this.addForm.reportTime,
            reportDevice: this.addForm.reportDevice,
            reportImages: this.addForm.reportImages,
            reportVideos: '',
            lng: '',
            lat: ''
          }
          this.$fetch(api.addReport, params).then((response) => {
            if (response.success) {
              this.$message.success(response.msgContent)
              this.addVisible = false
              this.getList()
            } else {
              this.$message.error(response.msgContent);
            }
          });
        }
      })
    },
    getImgPath(item) {
      return item ? utils.Bus.imgPath(item) : "";
    },
    onSuccessFile(res, file, fileList) {
      let imgCodeArr = []
      this.fileList = fileList;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.success) {
          imgCodeArr.push(this.fileList[i].response.returnObj[0].fileId)
        }
      }
      this.addForm.reportImages = imgCodeArr.join(',')
    },
    handleRemove(file, fileList) {
      let imgCodeArr = []
      this.fileList = fileList;
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].response.success) {
          imgCodeArr.push(this.fileList[i].response.returnObj[0].fileId)
        }
      }
      this.addForm.reportImages = imgCodeArr.join(',')
    },
    reportLevelRender(value) {
      if (Number(value) === 1) {
        return "特急";
      } else if (Number(value) === 2) {
        return "紧急";
      } else if (Number(value) === 3) {
        return "一般";
      }
      return "";
    },
    reportStatesRender(value) {
      if (Number(value) === 1) {
        return "待处理";
      } else if (Number(value) === 2) {
        return "已取消";
      } else if (Number(value) === 3) {
        return "处理中";
      } else if (Number(value) === 4) {
        return "待确认";
      } else if (Number(value) === 5) {
        return "已完成";
      }
      return "";
    },
    // 查看详情
    handleView(row) {
      this.detailForm.phone = row.phone
      this.detailForm.factory = row.factory
      this.detailForm.reportCode = row.reportCode
      this.detailForm.reportStates = row.reportStates
      this.detailForm.reportTime = row.reportTime
      this.detailForm.reportLevel = row.reportLevel
      this.detailForm.personName = row.personName
      this.detailForm.deviceName = row.deviceName
      this.detailForm.reportName = row.reportName
      this.detailForm.reportPosition = row.reportPosition
      this.detailForm.reportImages = row.reportImages
      if (this.detailForm.reportImages != '') {
        this.detailForm.reportImagesArr = row.reportImages.split(',')
      }
      this.detailVisible = true
    },
    detailCancel() {
      this.detailForm.reportImagesArr = []
      this.detailVisible = false
    },
    detailDialogClose() {
      this.detailForm.reportImagesArr = []
      this.detailVisible = false
    },
    receivePeople(val) {
      let person = []
      let personName = []
      for (let i = 0; i < val.length; i++) {
        person.push(val[i].accountNumber)
        personName.push(val[i].nickName)
      }
      this.dealForm.person = person.join(',')
      this.dealForm.operatePerson = personName.join(',')
    },
    peopleSelect() {
      this.dealForm.operatePerson = ''
      this.dealForm.person = ''
      this.$refs.peopleSelect.handleResetMaterials()
      this.$refs.peopleSelect.openDialog()
    },
    // 处置
    handleDeal(row) {
      this.dealForm.reportCode = row.reportCode
      this.dealForm.reportStates = 3
      this.dealForm.taskName = row.reportName
      this.dealForm.taskLevel = ''
      this.dealForm.person = ''
      this.dealForm.operatePerson = ''
      this.dealForm.taskTime = ''
      this.dealForm.taskAsk = ''
      this.dealVisible = true
    },
    dealCancel() {
      this.dealVisible = false
    },
    dealConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {}
          if (this.dealForm.reportStates === 3) {
            params = {
              reportCode: this.dealForm.reportCode,
              reportStates: 3,
              taskName: this.dealForm.taskName,
              taskLevel: this.dealForm.taskLevel,
              person: this.dealForm.person,
              operatePerson: this.dealForm.operatePerson,
              taskTime: this.dealForm.taskTime,
              taskAsk: this.dealForm.taskAsk
            }
          } else {
            params = {
              reportCode: this.dealForm.reportCode,
              reportStates: 2,
            }
          }
          this.$fetch(api.reportEvent, params).then((response) => {
            if (response.success) {
              this.$message.success(response.msgContent)
              this.dealVisible = false
              this.getList()
            } else {
              this.$message.error(response.msgContent);
            }
          });
        }
      })
    },
    // 删除
    handleDel(row) {
      const params = {
        id: row.id
      };
      this.$confirm("您确定要删除此条数据吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.deleteData, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList()
        });
      });
    }
  }
};
</script>
